import React, { useState, useEffect, useContext } from "react";

//import scss
import "./Mid-section-Pc.scss";

//icons
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { IoIosAddCircle } from "react-icons/io";

//import context
import { MyContext } from "../../../../tenantsDashContext";

//components
import TransactionsTable from "./Payments-Table";
import InformationCardPc from "./Information-Card-Pc";
import CreatePropertyModal from "./../../Properties/Pc-and-Large-Screens/CreatePropertyModal";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { getAllProperties } from "../../../../redux/slices/sliceActions";
import Carousel from "./Carousel";

const MiddleSectionPc = () => {
  const { currentProperty, setCurrentProperty } = useContext(MyContext);

  //redux methods
  const dispatch = useDispatch();

  //methods to fetch data
  useEffect(() => {
    dispatch(getAllProperties()).then((res) => {
      console.log("properties", res);
    });
  }, []);

  //data fetched from the store
  const { user, properties } = useSelector((state) => state.landlordslice);

  //check if there are properties
  const [propertiesPresent, setPropertiesPresent] = useState(true);
  useEffect(() => {
    console.log("properties", properties);
    if (properties?.length > 0) {
      setPropertiesPresent(true);
    } else {
      setPropertiesPresent(false);
    }
  }, [properties]);

  //display modal if no properties and properties, if properties are present
  const [isCreatePropertyModalOpen, setIsCreatePropertyModalOpen] =
    useState(false);

  // Extract dynamic property data for cards
  const occupiedHouses = currentProperty?.occupiedHouses || 0;
  const totalHouses = currentProperty?.totalHouses || 0;
  const occupiedPercentage =
    totalHouses > 0 ? Math.round((occupiedHouses / totalHouses) * 100) : 0;

  const totalPayments = currentProperty?.totalPayments || 0;

  // Pending invoices: houses with a tenant and hasMadeFirstPayment === false
  const pendingInvoices =
    currentProperty?.houses?.filter(
      (h) => h.tenant && h.tenant.hasMadeFirstPayment === false
    ).length || 0;

  return (
    <div className="mid-section-pc-caretaker">
      <div className="title-container">
        <div className="greeting">Hello {user?.data?.name}</div>
        <div className="title">Reports for <span style={{color:"#B39359"}}>{currentProperty?.name}</span></div>
      </div>
      <div className="cards-container">
        <InformationCardPc
          percentage={occupiedPercentage}
          Title={"Houses Occupied"}
          value={`${occupiedHouses} / ${totalHouses}`}
        />
        <InformationCardPc
          Title={"Payments Made"}
          percentage={0}
          value={`KES ${totalPayments}`}
        />
        <InformationCardPc
          Title={"Pending Invoices"}
          percentage={0}
          value={pendingInvoices}
        />
      </div>

      <div className="apartments-container">
        <div className="title-container" style={{ marginBottom: "0px" }}>
          <div className="title">My Apartments</div>
        </div>
        {propertiesPresent ? (
          <>
            <Carousel propertiesPassed={properties} />
          </>
        ) : (
          <div
            className="no-properties"
            onClick={() => setIsCreatePropertyModalOpen(true)}
          >
            <div className="icon">
              <HiOutlineBuildingOffice2 fontSize={50} />
              <IoIosAddCircle fontSize={50} className="add-icon" />
            </div>
            <div className="title">Properties</div>
            <div className="sub-title">No Properties created yet</div>
          </div>
        )}
      </div>

      <div className="transactions-container">
        <div className="title-container" style={{ marginBottom: "0px" }}>
          <div className="title">
            Latest Payments for{" "}
            <span style={{ color: "#B39359" }}>
              {currentProperty?.name || "Property"}
            </span>
          </div>
        </div>
        {propertiesPresent ? (
          <TransactionsTable currentProperty={currentProperty} />
        ) : (
          <div className="no-transactions">
            <div className="sub-title">No Payments yet</div>
            <div className="title">Payments will appear here</div>
          </div>
        )}
      </div>
      {isCreatePropertyModalOpen && (
        <CreatePropertyModal setShowModal={setIsCreatePropertyModalOpen} />
      )}
    </div>
  );
};

export default MiddleSectionPc;
